import React from "react";
import dynamic from "next/dynamic";
import { Section } from "..";
import { SeoContentListWrapper } from "./styles";

const SeoContentItem = dynamic(() =>
  import("../../elements/seo-content-item/seo-content-item")
);

export const SeoContentList = ({
  sectionTitle,
  sectionSubtitle,
  hideLineSeparation,
  seoContentItems,
  displaySetting

}) => {
  return (
    <Section
      title={sectionTitle}
      subtitle={sectionSubtitle}
      hideLine={hideLineSeparation}
      displayMode={displaySetting?.displayMode}
      smallMargin={displaySetting?.smallBottomMargin}
    >
      <SeoContentListWrapper>
        {seoContentItems.map((seoContentItem, index) => (
          <SeoContentItem key={`seoContentItem${index}`} {...seoContentItem} />
        ))}
      </SeoContentListWrapper>
    </Section>
  );
};

export default SeoContentList;
